<universal-modal-base>
  <ng-container modalHeader>
    <div class="locale-modal__header">
      @if (showLanguages()) {
        <button type="button" class="locale-modal__back" (click)="backToMarkets()">
          <fa-icon [icon]="['fal', 'angle-left']"></fa-icon>
          <span>{{ data.currentMarketLocale?.back_text || 'Back' }}</span>
        </button>
      } @else {
        <h2 class="locale-modal__title">{{ data.currentMarketLocale?.select_text || 'Select Market' }}</h2>
      }
    </div>
  </ng-container>

  <ng-container modalBody>
    @if (!showLanguages()) {
      <!-- Market list -->
      <ul class="locale-modal__list">
        @for (market of data.markets; track market.name) {
          <li class="locale-modal__item">
            <button
              type="button"
              class="locale-modal__button"
              (click)="selectMarket(market)"
              [attr.data-automation]="market.flag"
            >
              <span class="flag-icon flag-icon-{{ market.flag }}"></span>
              <span class="locale-modal__name">{{ market.name }}</span>
              @if (market.languages && market.languages.length > 1) {
                <fa-icon [icon]="['fal', 'angle-right']" class="locale-modal__arrow"></fa-icon>
              }
            </button>
          </li>
        }
      </ul>
    } @else {
      <!-- Language list for selected market -->
      <ul class="locale-modal__list">
        @for (language of selectedMarket()?.languages; track language.locale) {
          <li class="locale-modal__item">
            <button
              type="button"
              class="locale-modal__button"
              (click)="setLocale(language.locale)"
              [attr.data-automation]="language.locale"
            >
              <span class="locale-modal__name" [lang]="language.locale.split('-')[0]">{{ language.language }}</span>
            </button>
          </li>
        }
      </ul>
    }
  </ng-container>
</universal-modal-base>
